import {
  conditionDisclaimers,
  getDisclaimerAnchor,
  getDisclaimerAnchorLinkText,
  getDisclaimerDescriptionMarkup,
  getDisclaimerTypeByCondition,
} from './conditionDisclaimers';

import buildHtmlList from '../utils/buildHtmlList.js';
import { getHealthListJSON } from '../api/myev.js';
import { notifyHandledException } from '../utils/errorLogger';
import { setUpAccordionClickHandlers } from '../utils/clickHandlers.js';

const drawHealthList = async (mountNode) => {
  const healthListJSON = await getHealthListJSON();
  const disclaimersOutput = {};
  const categoriesHTML = Object.keys(healthListJSON).map((category) => {
    const conditionList = buildHtmlList(
      healthListJSON[category].map((condition) => {
        let disclaimerText = '';
        const disclaimerType = getDisclaimerTypeByCondition(condition);
        if (
          disclaimerType &&
          typeof conditionDisclaimers[disclaimerType] !== 'undefined'
        ) {
          const anchorID = getDisclaimerAnchor(
            disclaimerType,
            condition.health_id,
            'HealthList'
          );
          disclaimersOutput[disclaimerType] = anchorID;
          disclaimerText =
            '<br>' +
            getDisclaimerAnchorLinkText(
              anchorID,
              conditionDisclaimers[disclaimerType].anchorText
            );
        }
        return `<span class="bold">${condition.disorder_name}</span> ${condition.subdisorder_name}${disclaimerText}`;
      })
    );
    return `<h6>${category}</h6>${conditionList}`;
  });

  const healthListHTML = buildHtmlList(
    categoriesHTML,
    'accordion__root accordion',
    'accordion__item'
  );

  mountNode.insertAdjacentHTML('afterbegin', healthListHTML);

  Object.keys(disclaimersOutput).forEach((key) => {
    const disclaimerdescriptionMarkup = getDisclaimerDescriptionMarkup(
      disclaimersOutput[key],
      conditionDisclaimers[key].descriptionMarkup
    );

    if (disclaimerdescriptionMarkup) {
      mountNode.insertAdjacentHTML('afterend', disclaimerdescriptionMarkup);
    }
  }, disclaimersOutput);
};

function initHealthList() {
  const mountNode = document.getElementById('health-list-container');

  if (mountNode == null) {
    return;
  }

  drawHealthList(mountNode)
    .then(setUpAccordionClickHandlers)
    .catch(notifyHandledException);
}

export default initHealthList;
